<template>
  <div class="about">
    <h1>All about COCO</h1>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: "About",
}
</script>
